export class StockProduit {
    static jsonMap = {
        codeProduit: 'codeProduit',
        annee: 'annee',
        stock: 'stock'
    };

    codeProduit: string = undefined;
    annee: number = undefined;
    stock: number = undefined;
}
